import { render, staticRenderFns } from "./TunnelsRegister.vue?vue&type=template&id=7895fd47&scoped=true"
import script from "./TunnelsRegister.vue?vue&type=script&lang=js"
export * from "./TunnelsRegister.vue?vue&type=script&lang=js"
import style0 from "./TunnelsRegister.vue?vue&type=style&index=0&id=7895fd47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7895fd47",
  null
  
)

export default component.exports